import React, { useState, useEffect } from 'react';
import ReactSVG from 'react-svg';
import moment from 'moment';
import DateRangePicker from 'react-dates/lib/components/DateRangePicker';

import TimePicker from 'rc-time-picker';
import 'react-dates/initialize';
import customArrow from 'custom_datepicker_arrow.svg';
import DatepickerArrow from '../DatepickerArrow';
import useWindowSize from '../../hooks/useWindowSize';

export default function EventFormDateTime({
  start_date,
  end_date,
  start_time,
  end_time,
  all_day_event,
}) {
  const [focusedState, setFocusedState] = useState(null);
  const [allDay, setAllDay] = useState(false);
  const [localStartDate, setLocalStartDate] = useState(null);
  const [localEndDate, setLocalEndDate] = useState(null);
  const [localStartTime, setLocalStartTime] = useState(null);
  const [localEndTime, setLocalEndTime] = useState(null);

  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    setAllDay(all_day_event);
    if (start_date) setLocalStartDate(moment(start_date).add('1', 'd'));
    if (end_date) setLocalEndDate(moment(end_date).add('1', 'd'));
    if (start_time) setLocalStartTime(moment(start_time, 'HH:mm:ss'));
    if (end_time) setLocalEndTime(moment(end_time, 'HH:mm:ss'));
  }, [all_day_event, end_date, end_time, start_date, start_time]);

  return (
    <div>
      <div className="input custom-calendar-wrapper custom-form-datepicker-input">
        {/* eslint-disable-next-line */}
        <label style={{ marginRight: 'auto' }}>*Date</label>
        <DateRangePicker
          readOnly
          startDate={localStartDate}
          endDate={localEndDate}
          onDatesChange={({ startDate, endDate }) => {
            if (startDate) {
              setLocalStartDate(startDate);
              $('#event_start_date').val(startDate.format('YYYY-MM-DD'));
            }
            if (endDate) {
              setLocalEndDate(endDate);
              $('#event_end_date').val(endDate.format('YYYY-MM-DD'));
            }
          }}
          focusedInput={focusedState}
          onFocusChange={e => setFocusedState(e)}
          numberOfMonths={windowWidth <= 630 ? 1 : 2}
          minimumNights={0}
          noBorder
          navNext={<DatepickerArrow direction="next" />}
          navPrev={<DatepickerArrow direction="prev" />}
          customArrowIcon={<ReactSVG src={customArrow} />}
          isDayBlocked={day => {
            // block all days before today
            if (day.isBefore(moment().format('MM-DD-YYYY'))) {
              return true;
            }
          }}
        />
        {/* <% if f.object.errors.messages[:address][0] %>
          <span class="error">Address <%= f.object.errors.messages[:address][0] %></span>
        <% end %> */}
      </div>

      <div
        className={`input custom-form-timepicker-input small-margin ${
          allDay ? 'disabled' : ''
        }`}
      >
        {/* eslint-disable-next-line */}
        <label>*Time</label>
        <section className="timepicker-wrapper">
          <TimePicker
            inputReadOnly
            value={localStartTime}
            placeholder="Start Time"
            use12Hours
            showSecond={false}
            format="h:mm a"
            allowEmpty={false}
            disabled={allDay}
            onChange={startTime => {
              setLocalStartTime(startTime);
              $('#event_start_time').val(startTime.format('H:mm'));
            }}
            popupClassName="custom-time-picker"
          />
          <ReactSVG src={customArrow} />
          <TimePicker
            inputReadOnly
            value={localEndTime}
            placeholder="End Time"
            use12Hours
            showSecond={false}
            format="h:mm a"
            allowEmpty={false}
            disabled={allDay}
            onChange={endTime => {
              setLocalEndTime(endTime);
              $('#event_end_time').val(endTime.format('H:mm'));
            }}
          />
        </section>
      </div>

      <div className="input boolean">
        <label className="checkbox" htmlFor="event_all_day">
          <input
            aria-label="Toggle All Day"
            type="checkbox"
            id="event_all_day"
            checked={allDay}
            onChange={() => {
              if (allDay) {
                $('#event_all_day_event').val(false);
                setAllDay(false);
              } else {
                $('#event_all_day_event').val(true);
                setAllDay(true);
              }
            }}
          />
        </label>
        <span className="hint">All day event</span>
      </div>
    </div>
  );
}
